import { SelectMui } from 'src/components/SelectMui'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const CustomSelect = styled(SelectMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`

export const CustomInputText = styled(TextFieldMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`

export const CustomButton = styled(ButtonMui)`
  width: 12rem;
  height: 2.5rem !important;
  margin: 0 !important;
`
